var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "90px",
    height: "52px",
    viewBox: "0 0 90 52",
    enableBackground: "new 0 0 90 52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE600",
    d: "M38.866,0H22.48L0,38.087L8.213,52h16.269l6.193-10.491L36.867,52h16.268l6.193-10.492L65.521,52h16.265 L90,38.083L67.52,0H51.133l-6.132,10.391L38.866,0z M55.227,3.444H65.51l19.415,32.888H74.641L55.227,3.444z M26.572,3.444h10.285 l19.417,32.888H45.986L26.572,3.444z M22.472,48.557H12.189l11.322-19.183l5.142,8.711L22.472,48.557z M4.041,38.087l19.47-32.981 l19.47,32.979l-5.144,8.711L23.511,22.528L9.186,46.798L4.041,38.087z M51.126,48.557H40.844l5.18-8.781h10.283L51.126,48.557z  M66.49,46.796L47.021,13.814l5.143-8.712l19.468,32.98L66.49,46.796z M79.777,48.557H69.494l5.182-8.781H84.96L79.777,48.557z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYellow);
export default __webpack_public_path__ + "static/media/logo-yellow.249beb6b6112fc8238bc43392779d91a.svg";
export { ForwardRef as ReactComponent };